import { FC, useContext, useEffect, useMemo, useRef, useState } from "react";
import { InfoContext } from "../../../shared/contexts";
import { PageHeader } from "../../../shared/components/MainLayout/components";
import { ColSize, RowSize } from "../../../shared/components";
import { Tab, Tabs } from "@hdi-seguros/web-components.tabs";
import 'dayjs/locale/es';
import dayjs from "dayjs";
import { AutomaticDebitsRejectedTabs } from "./components/AutomaticDebitTabs";
import { REJECTIONS_TYPES_VALUES } from "./components/shared/enums/rejections-types-enum";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import { DEBIT_REJECTIONS_TABS_KEY_VALUES } from "./enums/debit-rejections-tabs-values-enum";

interface AutomaticRejectDebitsProps {
    title: string;
}

export const AutomaticRejectDebits: FC<AutomaticRejectDebitsProps> = ({title}) => {
    const { setTitle } = useContext(InfoContext);
    const [activeTab, setActiveTab] = useState(DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_CREDITS.toString());

    const handlePressTab = (activeTab: string) => setActiveTab(activeTab);
    const childRef1 = useRef<{ downloadExcel: () => void, downloadPDF: () => void  }>(null);
    const childRef2 = useRef<{ downloadExcel: () => void, downloadPDF: () => void  }>(null);
    dayjs.locale('es');   

    useEffect(() => {
        setTitle(title);
        // eslint-disable-next-line
    }, []);

    const TABS: Array<Tab> = useMemo(() => [
        {
            label: 'Tarjeta de credito',
            children: (
                <AutomaticDebitsRejectedTabs ref={childRef1} type={REJECTIONS_TYPES_VALUES.CREDITO} />
            ),
            key: DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_CREDITS,
            closable: false,
        },
        {
            label: 'Débito bancario',
            children: (
                <AutomaticDebitsRejectedTabs ref={childRef2} type={REJECTIONS_TYPES_VALUES.DEBITO} />
            ),
            key: DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_DEBITS,
            closable: false,
        }
    ], []);

    const handleDownloadPDF = () => {
        if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_CREDITS && childRef1.current) {
            childRef1.current.downloadPDF();
        } else if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_DEBITS && childRef2.current) {
            childRef2.current.downloadPDF();
        }
    };
    
    const handleDownloadExcel = () => {        
        if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_CREDITS && childRef1.current) {
            childRef1.current.downloadExcel();
        } else if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.REJECTIONS_DEBITS && childRef2.current) {
            childRef2.current.downloadExcel();
        }
    };

    const actions = useMemo(
        () => [
            {
                label: 'Descargar Excel',
                icon: <DownloadOutlined />,
                onClick: handleDownloadExcel,
            },
            {
                label: 'Descargar PDF',
                icon: <FilePdfOutlined />,
                onClick: handleDownloadPDF,
            },
        ],
        [handleDownloadExcel, handleDownloadPDF, activeTab]
    );

    return (
            <>
                <PageHeader actions={actions} />
                <RowSize>
                    <ColSize size={100}>
                        <Tabs 
                            onChange={(key) => setActiveTab(key)}
                            handlePressTab={ handlePressTab }
                            activeKey={activeTab}
                            items={ TABS }
                        />
                    </ColSize>
                </RowSize>
            </>
        )
}